export function setupWhatsapp() {
  console.log('[Customer Service] WhatsApp Business Ready')
  return null
}

export function openWhatsapp(id) {
  const whatsappUrl = `https://wa.me/${id}`
  window.open(whatsappUrl, '_blank', 'noopener,noreferrer')
}
